import { select } from "@angular-redux/store";
import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { Observable } from "rxjs/Observable";
import { ApplicationUser } from "../../../pb-screen/models/application.user.interface";

import { SharedActions } from "../../shared.actions";
import { Driver } from "../../../static/models/driver.interface";
import { CapacitySlot } from "../../models/capacity-slot.interface";
import { HttpClientService } from "../../services/httpclient";
import * as moment from "moment";

@Component({
  selector: "depot-capacity-selector",
  templateUrl: "./capacity-selector.component.html",
})
export class DepotCapacitySelectorComponent implements OnInit {

  @Output() public capacitySelection: EventEmitter<CapacitySlot> = new EventEmitter();
  @Output() public planDateSelection: EventEmitter<string> = new EventEmitter();
  @Output() public driverSelection: EventEmitter<Driver> = new EventEmitter();
  @select("capacitySlots") public capacitySlots$: Observable<CapacitySlot[]>;
  @Input() public selectedCapacity: CapacitySlot = undefined;
  @Input() public hasError: boolean;
  @Input() public selectedDriver: Driver;
  @select("drivers") public drivers$: Observable<Driver[]>;
  @select("applicationUser") public applicationUser$: Observable<ApplicationUser>;
  public enableAutocomplete: boolean = false;
  @select("planningGroupString") planningGroupString$: Observable<string>;

  public pgString: string = "";
  public capacitySlots: CapacitySlot[];
  public planDate: Date;
  public apiFormattedDate: string;

  public disabledCapacityInput: boolean = false;
  public disabledDateInput: boolean = false;
  public emptyCapacity: CapacitySlot;
  public user: ApplicationUser;
  public drivers: Driver[] = [];
  public disabledDriverInput: boolean = false;
  planDateHasChanged: boolean;

  constructor(
    private readonly sharedActions: SharedActions,
    public readonly httpClientService: HttpClientService
  ) {
  }

  public ngOnInit() {
    this.setInitialPlanDate();
    this.formatDateForApi();
    this.planDateSelection.emit(this.apiFormattedDate);
    this.sharedActions.getDrivers();
    this.planningGroupString$.subscribe((data) => {
      this.pgString = data;
    });
    this.applicationUser$.subscribe((data) => {
      if (data) {
        this.user = data;
        this.enableAutocomplete = data.generalSetting.enableAutocomplete;
      }
    });

    this.drivers$.subscribe((drivers: Driver[]) => {
      this.drivers = drivers;
    });

    this.capacitySlots$.subscribe((capacitySlots: CapacitySlot[]) => {
      this.capacitySlots = capacitySlots;
    });

    this.updatePlanDate(this.planDate);
  }

  public updatePlanDate($event) {
    // the current selection needs to be reset when a new list of capacities is fetched
    // had to force undefined,to fix the null value bug
   
    if($event !=null && this.planDate != $event ) {
   
      this.planDate = $event;  
      this.planDateHasChanged = true; 
      
    }
   
  }
  public fetchPlanningData() { 
    if (this.planDateHasChanged && this.planDate) {
    this.selectedCapacity = undefined;
    this.selectedDriver = undefined;
    this.capacitySlots = [];

    this.updateCapacitySlots();
    this.formatDateForApi();
    this.planDateSelection.emit(this.apiFormattedDate);
    this.capacitySelection.emit(this.selectedCapacity);
      this.planDateHasChanged = false;
    }
  }


  public updateCapacitySelection(data: CapacitySlot) {
    if (data) {
      this.capacitySelection.emit(this.selectedCapacity);
    }
    if (data && data.driver && data.driver.id) {
      this.selectedDriver = this.drivers.filter((driver) => driver.id === data.driver.id.toString())[0];

    }
  }

  public driverListFormatter(data: Driver): string {
    return data.name;
  }

  public driverAutocompleListFormatter(data: Driver): string {
    return data.name;
  }

  public updateCapacitySlots() {
    this.formatDateForApi();
    this.httpClientService.getToken().subscribe(_ => {
      // if (this.pgString !== "" && this.pgString !== null) {
      //   this.sharedActions.getCapacitySlotsCpl(this.apiFormattedDate, this.pgString);
      // } else {
      //   this.sharedActions.getCapacitySlotsCpl(this.apiFormattedDate, "ALL");
      // }
      this.sharedActions.getCapacitySlotsCpl(this.apiFormattedDate, "ALL");
    });
  }

  public formatDateForApi(passedPlanDate?: Date) { 
    if (passedPlanDate) { 
      this.apiFormattedDate = moment(passedPlanDate).format("YYYY-MM-DD");
    }
    else {
    this.apiFormattedDate = moment(this.planDate).format("YYYY-MM-DD");
    }
  }

  public setSelectionFromParent(capacity: string): CapacitySlot {
    const foundCapacity = this.capacitySlots.find((x) => x.truck.name === capacity);
    if (foundCapacity) {
      this.selectedCapacity = foundCapacity;
    } else {
      this.selectedCapacity = this.emptyCapacity;
    }

    return this.selectedCapacity;
  }

  public autocompleListFormatter(data: any): string {
    if (data.driver.name != null) {
      return `${data.truck.name} - ${data.driver.name}`;
    } else {
      return `${data.truck.name} `;
    }
  }

  public valueListFormatter(data: any): string {
    if (data.driver.name != null) {
      return `${data.truck.name} - ${data.driver.name}`;
    } else {
      return `${data.truck.name} `;
    }
  }

  public enableCapacityInput() {
    this.disabledCapacityInput = false;
  }

  public disableCapacityInput() {
    this.disabledCapacityInput = true;
  }

  public disableDateInput() {
    this.disabledDateInput = true;
  }

  public setInitialPlanDate() {
    const currentDate = new Date();
    const currentDateHours = currentDate.getHours();

    if (this.isHourBetweenMidnightAndFiveAm(currentDateHours)) {
      this.setPlanDateToPreviousDay(currentDate);
    } else {
      this.planDate = currentDate;
    }
  }

  public setPlanDateToPreviousDay(currentDate) {
    const subtractXDays = 1;
    const newDate = new Date();

    newDate.setDate(currentDate.getDate() - subtractXDays);
    this.planDate = newDate;
    var tzoffset = (new Date()).getTimezoneOffset() * 60000; // offset in milliseconds
    this.planDate = (new Date(newDate as any - tzoffset));

  }

  public isHourBetweenMidnightAndFiveAm(currentDateHours) {
    return currentDateHours >= 0 && currentDateHours < 5;
  }

  public updateDriverSelection(_: Driver) {
    if (this.selectedCapacity && this.selectedCapacity.driver && this.selectedCapacity.driver.id) {
      this.selectedCapacity = undefined;
    }
    const driverCapacity = this.capacitySlots.find(cs => cs.driver && cs.driver.id && cs.driver.id.toString() == this.selectedDriver.id);
    if (driverCapacity && driverCapacity.id) {
      this.selectedCapacity = driverCapacity;
    }
    this.driverSelection.emit(this.selectedDriver);
    this.capacitySelection.emit(this.selectedCapacity);
  }
}
